import axios from 'axios';
import constants from '@/constants';
// import authService from '../auth/AuthService'; // acquire token from getters['oidcStore/oidcAccessToken']
import moment from 'moment';
import { milestones } from './devdata';

export default {
  getForPeriod(startDate, endDate, teamFilter) {
    return new Promise((resolve, reject) => { resolve(milestones); });
    // return new Promise(function(resolve, reject) {
    //   authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.read'])
    //   .then(accessToken => {
    //     const headers = { 'Authorization': `Bearer ${accessToken}` };
    //     const options = {
    //       headers
    //     };
    //     axios.get(`${constants.planningApiBasePath}/milestones/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forteam=${(teamFilter ? teamFilter : '')}`, options)
    //       .then(response => {
    //         resolve(response);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   }).catch(error => {
    //     reject(error);
    //   });
    // });
  },
  create(
    name,
    milestoneType,
    projectId,
    date,
    percentageCompleted,) {
      return new Promise((resolve, reject) => { resolve(); });
      // return new Promise(function(resolve, reject) {
      //   authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.manage'])
      //   .then(accessToken => {
      //     const headers = { 'Authorization': `Bearer ${accessToken}` };
      //     const options = {
      //       headers
      //     };
      //     axios
      //     .post(`${constants.planningApiBasePath}/milestones`, {
      //         name: name,
      //         projectId: projectId,
      //         milestoneType: milestoneType,
      //         date: date,
      //         percentageCompleted: percentageCompleted,
      //       }, options)
      //       .then(response => {
      //         resolve(response);
      //       })
      //       .catch(error => {
      //         reject(error);
      //       });
      //   }).catch(error => {
      //     reject(error);
      //   });
      // });
  },
  update(milestone) {
    return new Promise((resolve, reject) => { resolve(milestone); });
    // return new Promise(function(resolve, reject) {
    //   authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.manage'])
    //   .then(accessToken => {
    //     const headers = { 'Authorization': `Bearer ${accessToken}` };
    //     const options = {
    //       headers
    //     };
    //     axios
    //     .put(`${constants.planningApiBasePath}/milestones`, milestone, options)
    //       .then(response => {
    //         resolve(response);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   }).catch(error => {
    //     reject(error);
    //   });
    // });
  },
  delete(milestoneId, updateTag) {
    return new Promise((resolve, reject) => { resolve([]); });
    // return new Promise(function(resolve, reject) {
    //   authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.manage'])
    //   .then(accessToken => {
    //     const headers = { 'Authorization': `Bearer ${accessToken}` };
    //     const options = {
    //       headers
    //     };
    //     axios
    //     .delete(`${constants.planningApiBasePath}/milestones/${milestoneId}?updateTag=${updateTag}`, options)
    //       .then(response => {
    //         resolve(response);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   }).catch(error => {
    //     reject(error);
    //   });
    // });
  },
};
